var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useMemo, useState } from 'react';
import { EyeTableIcon } from '@/presentation/components/icons';
import { useRecoilState } from 'recoil';
import { IconButton } from '../components';
import { useNavigate } from 'react-router';
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request';
import { manageModulesState } from '../pages/manage-modules/components/atoms';
import useUserSesssion from './use-user-session';
import Eye from '../components/icons/eye';
import { encodeBase64 } from '../utils/base64-utils';
const UseManageModule = (manageUsers, getModulesFiltered) => {
    var _a, _b;
    const { user: userDatabase, currentUserSession, getIdClient } = useUserSesssion();
    const [showAlert, setShowAlert] = useState(false);
    const [checked, setCheked] = useState(false);
    const [firstChecked, setFirstChecked] = useState(0);
    const [modules, setModules] = useState([]);
    const [cities, setCities] = useState([]);
    const [states, setStates] = useState([]);
    const [dataNotFound, setDataNotFound] = useState(false);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        input: '',
        grades: '',
        deleted: false
    });
    const [manageModulesStateUse, setManageModulesStateUse] = useRecoilState(manageModulesState);
    const [showAddModule, setShowAddModule] = useState(false);
    const [isEditingModule, setIsEditingModule] = useState(false);
    const [showRemoveModule, setShowRemoveModule] = useState(false);
    const [amountOfModules, setAmountOfModules] = useState(10);
    const [openModalPreview, setOpenModalPreview] = useState(false);
    const [allActiveModules, setAllActiveModules] = useState([]);
    const userRole = (_a = userDatabase === null || userDatabase === void 0 ? void 0 : userDatabase.role) === null || _a === void 0 ? void 0 : _a.description;
    const navigate = useNavigate();
    const subscription = currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.subscription;
    const isTrial = (subscription === null || subscription === void 0 ? void 0 : subscription.status) === 'trialing';
    const idClient = getIdClient();
    const changeLoading = (value) => {
        setLoading(value);
        setManageModulesStateUse(prev => {
            return Object.assign(Object.assign({}, prev), { isLoading: value });
        });
    };
    const getStudentGradeIds = () => __awaiter(void 0, void 0, void 0, function* () {
        const cacheKey = `client-student-grades-${idClient}-${userDatabase === null || userDatabase === void 0 ? void 0 : userDatabase.id}`;
        const cachedGrades = sessionStorage.getItem(cacheKey);
        if (cachedGrades) {
            return JSON.parse(cachedGrades);
        }
        try {
            const qb = RequestQueryBuilder.create();
            qb.setJoin({ field: 'client' });
            qb.setJoin({ field: 'classesS' });
            qb.setFilter({ field: 'userClient.id', operator: CondOperator.EQUALS, value: idClient });
            qb.setFilter({
                field: 'userRole.description',
                operator: CondOperator.EQUALS,
                value: 'Student'
            });
            if (!manageUsers) {
                return [];
            }
            const students = yield manageUsers.find({ queryBuilder: qb });
            const grades = [];
            students.forEach(student => {
                var _a;
                (_a = student === null || student === void 0 ? void 0 : student.classesS) === null || _a === void 0 ? void 0 : _a.forEach((classS) => {
                    if (classS.grades) {
                        grades.push(...classS.grades);
                    }
                });
            });
            sessionStorage.setItem(cacheKey, JSON.stringify(grades));
            return grades;
        }
        catch (error) {
            console.error('Error getting student grade ids', error === null || error === void 0 ? void 0 : error.message);
            return [];
        }
    });
    const getModulesData = (deleted, pagination = {
        pageIndex: 1,
        pageSize: 10
    }) => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        changeLoading(true);
        const studentGradeIds = yield getStudentGradeIds();
        const qb = RequestQueryBuilder.create();
        qb.setLimit(pagination.pageSize);
        qb.setPage(pagination.pageIndex);
        qb.setJoin({
            field: 'status'
        });
        qb.setJoin({
            field: 'lessons'
        });
        qb.setJoin({
            field: 'lessons.lesson'
        });
        qb.setJoin({
            field: 'lessons.status'
        });
        const andConditions = [];
        andConditions.push({ 'moduleStatus.valueDefinition': { $in: ['010'] } });
        andConditions.push({ grades: { JSON_CONTAINS: studentGradeIds } });
        if (andConditions.length > 0) {
            const searchQuery = { $and: andConditions };
            qb.search(searchQuery);
        }
        qb.query();
        qb.sortBy([
            { field: 'orden', order: 'ASC' },
            { field: 'id', order: 'ASC' }
        ]);
        if (!getModulesFiltered) {
            return;
        }
        const modulesInt = yield getModulesFiltered.getModuleListByAdmin((_c = userDatabase === null || userDatabase === void 0 ? void 0 : userDatabase.id) === null || _c === void 0 ? void 0 : _c.toString(), filters.input, qb, userRole);
        changeLoading(false);
        const data = modulesInt.data;
        const mappedData = data.map((d, index) => {
            return {
                id: d.id,
                name: d.name,
                summary: d.summary,
                grades: d.grades,
                status: d.status,
                lessons: d.lessons,
                createdAt: d.createdAt,
                creatorUserId: d.creatorUserId,
                updatedAt: d.updatedAt,
                modifierUserId: d.modifierUserId,
                orden: d.orden,
                isFirstModule: index === 0
            };
        });
        if (modulesInt && modulesInt.total > 0 && data.length > 0) {
            setManageModulesStateUse(prev => {
                return Object.assign(Object.assign(Object.assign({}, prev), { modules: mappedData }), modulesInt);
            });
            const newData = mappedData.map(item => Object.assign({}, item, {
                view: (React.createElement(EyeTableIcon, { onClick: () => {
                        window.alert(`${item.name} 222`);
                    } }))
            }));
            setModules(newData);
            setDataNotFound(false);
        }
        else {
            setDataNotFound(true);
        }
    });
    const getModulesFilteredList = (filter, pagination = {
        pageIndex: 1,
        pageSize: 10
    }, sort) => __awaiter(void 0, void 0, void 0, function* () {
        var _d;
        changeLoading(true);
        const qb = RequestQueryBuilder.create();
        qb.setLimit(pagination.pageSize);
        qb.setPage(pagination.pageIndex);
        qb.setJoin({
            field: 'status'
        });
        qb.setJoin({
            field: 'lessons'
        });
        qb.setJoin({
            field: 'lessons.lesson'
        });
        qb.setJoin({
            field: 'lessons.status'
        });
        const andConditions = [];
        const searchQuery = {};
        if (filter.deleted) {
            andConditions.push({ 'moduleStatus.valueDefinition': { $in: ['010', '020'] } });
        }
        else {
            andConditions.push({ 'moduleStatus.valueDefinition': { $in: ['010'] } });
        }
        if (filters.input) {
            if (filters.input && filters.input.length > 0) {
                andConditions.push({
                    $or: [
                        { name: { $cont: filters.input } },
                        { description: { $cont: filters.input } },
                        { summary: { $cont: filters.input } }
                    ]
                });
            }
        }
        if (andConditions.length > 0) {
            searchQuery.$and = andConditions;
        }
        qb.search(searchQuery);
        if (sort) {
            if (sort.field) {
                qb.sortBy({
                    field: sort.field,
                    order: sort.order === 1 ? 'ASC' : 'DESC'
                });
            }
        }
        const modulesInt = yield getModulesFiltered.getModuleListByAdmin((_d = userDatabase === null || userDatabase === void 0 ? void 0 : userDatabase.id) === null || _d === void 0 ? void 0 : _d.toString(), filters.input, qb, userRole);
        changeLoading(false);
        const data = modulesInt.data;
        const mappedData = data.map((d, index) => {
            return {
                id: d.id,
                name: d.name,
                summary: d.summary,
                grades: d.grades,
                lessons: d.lessons,
                status: d.status,
                createdAt: d.createdAt,
                creatorUserId: d.creatorUserId,
                updatedAt: d.updatedAt,
                modifierUserId: d.modifierUserId,
                isFirstModule: index === 0
            };
        });
        if (modulesInt && modulesInt.total > 0 && data.length > 0) {
            setManageModulesStateUse(prev => {
                return Object.assign(Object.assign(Object.assign({}, prev), { modules: mappedData }), modulesInt);
            });
            const newData = mappedData.map(item => Object.assign({}, item, {
                view: (React.createElement(EyeTableIcon, { onClick: () => {
                        window.alert(`${item.name} 222`);
                    } }))
            }));
            setModules(newData);
            setDataNotFound(false);
        }
        else {
            setDataNotFound(true);
        }
    });
    const getModulesGetData = (deleted, pagination = {
        pageIndex: 1,
        pageSize: 10
    }) => __awaiter(void 0, void 0, void 0, function* () {
        changeLoading(true);
        const qb = RequestQueryBuilder.create();
        qb.setLimit(pagination.pageSize);
        qb.setPage(pagination.pageIndex);
        qb.setJoin({
            field: 'status'
        });
        qb.setJoin({
            field: 'lessons'
        });
        qb.setJoin({
            field: 'lessons.lesson'
        });
        qb.setJoin({
            field: 'lessons.status'
        });
        const andConditions = [];
        andConditions.push({ 'moduleStatus.valueDefinition': { $in: ['010'] } });
        if (andConditions.length > 0) {
            const searchQuery = { $and: andConditions };
            qb.search(searchQuery);
        }
        qb.query();
        qb.sortBy([
            { field: 'orden', order: 'ASC' },
            { field: 'id', order: 'ASC' }
        ]);
        const modulesInt = yield getModulesFiltered.getModuleDataList(qb);
        changeLoading(false);
        const data = modulesInt.data;
        const mappedData = data.map(d => {
            return {
                id: d.id,
                name: d.name,
                summary: d.summary,
                grades: d.grades,
                status: d.status,
                lessons: d.lessons,
                createdAt: d.createdAt,
                creatorUserId: d.creatorUserId,
                updatedAt: d.updatedAt,
                modifierUserId: d.modifierUserId,
                orden: d.orden
            };
        });
        if (modulesInt && modulesInt.total > 0 && data.length > 0) {
            setManageModulesStateUse(prev => {
                return Object.assign(Object.assign(Object.assign({}, prev), { modules: mappedData }), modulesInt);
            });
            const newData = mappedData.map(item => Object.assign({}, item, {
                view: (React.createElement(EyeTableIcon, { onClick: () => {
                        window.alert(`${item.name} 222`);
                    } }))
            }));
            setModules(newData);
            setDataNotFound(false);
        }
        else {
            setDataNotFound(true);
        }
    });
    const getModuleGetFilteredList = (filter, pagination = {
        pageIndex: 1,
        pageSize: 10
    }, sort) => __awaiter(void 0, void 0, void 0, function* () {
        changeLoading(true);
        const qb = RequestQueryBuilder.create();
        qb.setLimit(pagination.pageSize);
        qb.setPage(pagination.pageIndex);
        qb.setJoin({
            field: 'status'
        });
        qb.setJoin({
            field: 'lessons'
        });
        qb.setJoin({
            field: 'lessons.lesson'
        });
        qb.setJoin({
            field: 'lessons.status'
        });
        const andConditions = [];
        const searchQuery = {};
        if (filter.deleted) {
            andConditions.push({ 'moduleStatus.valueDefinition': { $in: ['010', '020'] } });
        }
        else {
            andConditions.push({ 'moduleStatus.valueDefinition': { $in: ['010'] } });
        }
        if (filters.input) {
            if (filters.input && filters.input.length > 0) {
                andConditions.push({
                    $or: [
                        { name: { $cont: filters.input } },
                        { description: { $cont: filters.input } },
                        { summary: { $cont: filters.input } }
                    ]
                });
            }
        }
        if (andConditions.length > 0) {
            searchQuery.$and = andConditions;
        }
        qb.search(searchQuery);
        if (sort) {
            if (sort.field) {
                qb.sortBy({
                    field: sort.field,
                    order: sort.order === 1 ? 'ASC' : 'DESC'
                });
            }
        }
        const modulesInt = yield getModulesFiltered.getModuleDataList(qb);
        changeLoading(false);
        const data = modulesInt.data;
        const mappedData = data.map(d => {
            return {
                id: d.id,
                name: d.name,
                summary: d.summary,
                grades: d.grades,
                lessons: d.lessons,
                status: d.status,
                createdAt: d.createdAt,
                creatorUserId: d.creatorUserId,
                updatedAt: d.updatedAt,
                modifierUserId: d.modifierUserId
            };
        });
        if (modulesInt && modulesInt.total > 0 && data.length > 0) {
            setManageModulesStateUse(prev => {
                return Object.assign(Object.assign(Object.assign({}, prev), { modules: mappedData }), modulesInt);
            });
            const newData = mappedData.map(item => Object.assign({}, item, {
                view: (React.createElement(EyeTableIcon, { onClick: () => {
                        window.alert(`${item.name} 222`);
                    } }))
            }));
            setModules(newData);
            setDataNotFound(false);
        }
        else {
            setDataNotFound(true);
        }
    });
    useEffect(() => {
        if (firstChecked !== 0) {
            getModulesFilteredList(filters);
        }
    }, [filters.grades, filters.input, filters.deleted]);
    useEffect(() => {
        getModulesData();
        setFirstChecked(1);
    }, []);
    const columnAlternativeNames = {
        name: 'Module Name',
        summary: 'Summary',
        status: '# of Lessons',
        view: 'View'
    };
    useEffect(() => {
        if (firstChecked !== 0) {
            getModulesFilteredList(filters, {
                pageIndex: 1,
                pageSize: amountOfModules
            });
        }
    }, [filters.input]);
    const columnsWithoutSort = ['actions'];
    const setColumnsByModel = () => {
        const keys = [
            { id: 'name', field: 'name' },
            { id: 'summary', field: 'summary' },
            { id: 'status', field: 'moduleStatus.description' }
        ];
        let columns = keys.map(key => {
            return {
                accessorFn: row => row[key.id],
                id: key.id,
                field: key.field,
                cell: info => info.getValue(),
                header: () => React.createElement("span", null, columnAlternativeNames[key.id]),
                enableSorting: true
            };
        });
        columns.push({
            accessorFn: row => row.view,
            id: 'view',
            cell: info => info.getValue(),
            header: () => React.createElement("span", null, "View"),
            enableSorting: false,
            sortingFn: () => 0
        });
        columns = columns.map(column => {
            if (column.id === 'status') {
                column.sortingFn = () => 0;
            }
            if (column.id === 'status' || column.id === 'students' || column.id === 'createdAt') {
                column.maxSize = 12;
                column.size = 12;
                column.meta = {
                    styles: {
                        justifyContent: 'flex-start'
                    }
                };
            }
            else {
                column.maxSize = 30;
                column.size = 30;
            }
            if (column.id === 'view' || column.id === 'preview') {
                column.maxSize = 12;
                column.size = 12;
                column.meta = {
                    styles: {
                        justifyContent: 'center'
                    }
                };
            }
            return column;
        });
        return columns;
    };
    const dashboardPath = ((_b = userDatabase === null || userDatabase === void 0 ? void 0 : userDatabase.role) === null || _b === void 0 ? void 0 : _b.description) === 'Teacher' ? '/teacher-dashboard/' : '/school-dashboard/';
    const columns = useMemo(() => [...setColumnsByModel()], []);
    const renderCellByType = (context, original) => {
        var _a;
        const { column } = context;
        switch (column.id) {
            case 'status':
                return React.createElement("span", null, ((_a = original === null || original === void 0 ? void 0 : original.lessons) === null || _a === void 0 ? void 0 : _a.length) || 0);
            case 'name':
                return React.createElement("span", null, original === null || original === void 0 ? void 0 : original.name);
            case 'summary':
                return React.createElement("span", null, original === null || original === void 0 ? void 0 : original.summary);
            case 'view':
                return (React.createElement(IconButton, { onClick: () => {
                        if (isTrial) {
                            navigate(`${dashboardPath}modules/${original === null || original === void 0 ? void 0 : original.id}?viewMode=${encodeBase64((original === null || original === void 0 ? void 0 : original.isFirstModule) ? 'TRIAL_FIRST' : 'TRIAL')}`);
                        }
                        else {
                            navigate(`${dashboardPath}modules/${original === null || original === void 0 ? void 0 : original.id}?viewMode=${encodeBase64('NORMAL')}`);
                        }
                    } },
                    React.createElement(Eye, null)));
            default:
                return React.createElement("span", null);
        }
    };
    return {
        checked,
        setCheked,
        cities,
        columns,
        columnsWithoutSort,
        modules,
        states,
        getModulesFilteredList,
        filters,
        setFilters,
        showAlert,
        setShowAlert,
        getModulesData,
        manageModulesStateUse,
        dataNotFound,
        loading,
        setLoading,
        setDataNotFound,
        renderCellByType,
        showAddModule,
        setShowAddModule,
        setIsEditingModule,
        isEditingModule,
        showRemoveModule,
        setShowRemoveModule,
        allActiveModules,
        openModalPreview,
        setOpenModalPreview,
        getModuleGetFilteredList,
        getModulesGetData
    };
};
export default UseManageModule;
